export default __webpack_public_path__ + "static/media/bars.eb61de57.svg";